<script>
import BaseWidgetForm from './BaseWidgetForm'
import fields from '@/components/fields/'

export default {
  extends: BaseWidgetForm,
  created() {
    if (this.form.is_vimeo === undefined) {
      this.$set(this.form, 'is_vimeo', false)
    }
  },
  computed: {
    tabsFieldsSchema() {
      return [
        {
          label: 'Ogólne',
          fields: [
            ...this.getCommonFields(),
            new fields.Input({
              label: 'Tytuł',
              modelPath: [this, 'form', 'title'],
              required: true
            }),
            new fields.Input({
              label: 'Nazwa',
              type: 'textarea',
              modelPath: [this, 'form', 'name']
            }),
            new fields.Input({
              label: 'Tytuł w prawej kolumnie',
              type: 'textarea',
              modelPath: [this, 'form', 'right_title']
            }),
            new fields.Input({
              label: 'Stanowisko',
              modelPath: [this, 'form', 'position']
            }),
            new fields.Input({
              label: 'Opis',
              type: 'textarea',
              modelPath: [this, 'form', 'description']
            }),
            new fields.Image({
              label: 'Zdjęcie',
              modelPath: [this, 'form', 'image']
            }),
            new fields.Switch({
              label: 'Czarno-białe zdjęcie',
              modelPath: [this, 'form', 'is_black_and_white']
            }),
            {
              component: 'h3',
              innerText: 'Wideo'
            },
            new fields.Switch({
              label: 'Film z vimeo',
              modelPath: [this, 'form', 'is_vimeo']
            }),
            new fields.Video({
              label: 'Wideo',
              modelPath: [this, 'form', 'video'],
              condition: !this.form.is_vimeo
            }),
            new fields.Input({
              label: 'Link do Vimeo',
              modelPath: [this, 'form', 'video_url'],
              condition: this.form.is_vimeo
            })
          ]
        }
      ]
    }
  }
}
</script>
